var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.orderItem,"items-per-page":5,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.quantity",fn:function(ref){
var item = ref.item;
return [(!_vm.action)?_c('span',{staticClass:"body-1"},[_vm._v(" "+_vm._s(item.quantity)+" ")]):_c('span',{staticClass:"body-1"},[_vm._v(" 1 ")])]}},{key:"item.seller_sku",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"body-1"},[_vm._v(" "+_vm._s(item.product.sku)+" ")])]}},{key:"item.product.name",fn:function(ref){
var item = ref.item;
return [_c('span',{staticClass:"text-uppercase body-1"},[_vm._v(" "+_vm._s(item.product.name)+" ")])]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }